import o from"../isHostComponent/isHostComponent.js";function t(t,e,n){return void 0===t||o(t)?e:{...e,ownerState:{...e.ownerState,...n}}}export{t as default};
//# sourceMappingURL=appendOwnerState.js.map
